<div id="jobs-field-mapping" class="step-page">
	<div class="step-title">
		<div class="row-wrap">
			<div class="row-left">
				<div>
					{{title}}
				</div>
			</div>			
			<div class="row-right">
				<ng-content></ng-content>
			</div>
		</div>
	</div>
	<div class="step-content">
		<ng-container *ngFor="let msg of socketMsg; let idx = index;">
			<div class="msg-item" *ngIf="msg?.dataType==='print'||msg?.isError">
				<div class="msg-timestamp">{{msg.timeStamp}} &nbsp;&nbsp;</div>
				<div class="msg-content">
						{{msg.isError ? msg.data.errorMessage + ' ' + msg.data.errorDetail : msg.data}}
				</div>
			</div>
			<ng-container *ngIf="msg?.dataType==='printJson'&&msg?.data">
				<div *ngFor="let msgDataByCate of msg.data | keyvalue">
					<!-- <div class="msg-cate">{{msgDataByCate.key}}: </div> -->
					<div *ngFor="let msgData of msgDataByCate.value" class="msg-item" [ngClass]="{'err-msg': msgData.typ==='err'}">
						<div class="msg-timestamp">{{msgData.time}} &nbsp;&nbsp;</div>
						<div class="msg-content">
								{{msgData.print}}
						</div>
					</div>
				</div>
				<!-- <div *ngFor="let msgData of msg.data" class="msg-item" [ngClass]="{'err-msg': msgData.typ==='err'}">
					<div class="msg-timestamp">{{msgData.time}} &nbsp;&nbsp;</div>
					<div class="msg-content">
							{{msgData.print}}
					</div>
				</div> -->
			</ng-container>
		</ng-container>
	</div>
</div>
